import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function FilledStarGray({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M8.82227 2.05762C9.4588 1.24269 10.7535 1.3011 11.2959 2.23242L13.4434 5.91797L13.5049 6.00195C13.5744 6.07864 13.6667 6.133 13.7695 6.15527L17.9385 7.05762L18.1406 7.11621C19.0479 7.44612 19.4092 8.55726 18.8691 9.35742L18.7393 9.52344L15.8975 12.7041C15.8039 12.8088 15.7583 12.9482 15.7725 13.0879L16.2021 17.332L16.209 17.542C16.1756 18.5066 15.2314 19.1927 14.3037 18.9268L14.1055 18.8555L10.2012 17.1348C10.105 17.0925 9.99866 17.0823 9.89746 17.1035L9.79883 17.1348L5.89453 18.8555C4.84272 19.3187 3.68234 18.4755 3.79785 17.332L4.22754 13.0879L4.22656 12.9834C4.21914 12.915 4.1982 12.8488 4.16406 12.7891L4.10254 12.7041L1.26074 9.52344C0.494772 8.66619 0.937984 7.30096 2.06152 7.05762L6.23047 6.15527L6.33008 6.12207C6.42428 6.07965 6.50376 6.00871 6.55664 5.91797L8.7041 2.23242L8.82227 2.05762Z"
        fill="#F4F4F5"
        stroke="#E4E4E7"
      />
    </svg>
  )
}
